import { useState } from "react";
import { Lock, Loader2 } from "lucide-react";
import { Input } from "../ui/input";

const errorText = (err) => {
  if (err?.response?.status === 429) return "Too many attempts. Please wait 15 minutes.";
  if (err?.response?.status === 422) return "Enter a valid email address and your password.";
  return "Incorrect email or password. Please try again.";
};

export const AdminLogin = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await onLogin(email.trim(), password);
    } catch (err) {
      setError(errorText(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 pt-20">
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-md rounded-2xl border border-slate-200 bg-white shadow-xl p-8">
        <div className="w-14 h-14 rounded-2xl bg-cyan-50 border border-cyan-200 flex items-center justify-center mx-auto">
          <Lock className="w-6 h-6 text-cyan-700" />
        </div>
        <h1 className="mt-6 text-2xl font-bold text-slate-900 text-center">Leads Portal</h1>
        <p className="text-base text-slate-600 text-center mt-2">Sign in to view and manage quote requests.</p>
        <div className="mt-6 space-y-4">
          <Input
            data-testid="admin-email-input"
            type="email"
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            required
            className="bg-white border-slate-300 h-11"
          />
          <Input
            data-testid="admin-password-input"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            required
            className="bg-white border-slate-300 h-11"
          />
          {error && <p data-testid="admin-login-error" className="text-base text-red-700">{error}</p>}
          <button
            type="submit"
            data-testid="admin-login-submit"
            disabled={busy}
            className="w-full inline-flex items-center justify-center gap-2 bg-gradient-to-r from-cyan-600 to-teal-600 text-white font-bold px-6 py-3 rounded-xl disabled:opacity-60"
          >
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign In"}
          </button>
        </div>
      </form>
    </div>
  );
};
